export function getTop(inputJson, number = 10) {
  const jsonArray = Object.entries(inputJson);
  const sortedArray = jsonArray.sort((a, b) => b[1] - a[1]);
  const top = sortedArray.slice(0, number);
  return Object.fromEntries(top);

}
export function getObjectLen(inputJson) {
  const jsonArray = Object.entries(inputJson);
  return jsonArray.length;
}
export const getColorByIndex = (index) => {
  // Puedes personalizar tu lógica para asignar colores aquí
  const colors = [
    "#2caffe",
    "#544fc5",
    "#00e272",
    "#fe6a35",
    "#6b8abc",
    "#d568fb",
    "#2ee0ca",
    "#fa4b42",
    "#feb56a",
    "#91e8e1",
  ];
  return colors[index];
};
